import React from "react";
import { NumberField } from "./NumberField";

export class PercentageField extends NumberField {
    format(v: number) {
        if (v != null)
            v = v * 100;
        let res = super.format(v);
        return res + "%";
    }

    parse(v: string) {
        let res = super.parse(v);
        if (res == null) {
            return res;
        }
        return +(res/100).toFixed(4);
    }

    getErrorText(): string {
        let error = super.getErrorText();
        if (error) {
            return error;
        }

        let val = this.getValue();
        if (!this.props.required && (val == 0 || val == null))
            return null;

        if (val < 0.0001 || val > 1) {
            return `Percentage must be between 0.01 and 100`;
        }

        return null;
    }
}